import { styled } from '@/styles/stitches.config';

type TermsOfUseEsProps = {
  title: string;
};

const Section = styled('section', {
  marginBlock: '$8',
});

const H1 = styled('h1', {
  color: '$white',
  marginBlockEnd: '$8',
});

const H2 = styled('h2', {
  color: '$white',
  fontWeight: '$normal',
  fontSize: '$3',
});

const StyledA = styled('a', {
  color: '$white',
});

type AProps = {
  href: string;
  children: React.ReactNode;
};

const A = (props: AProps) => {
  return (
    <StyledA href={props.href} rel="noopener noreferrer" target={'_blank'}>
      {props.children}
    </StyledA>
  );
};

export function TermsOfUseEs(props: TermsOfUseEsProps) {
  const { title } = props;

  return (
    <>
      <H1>{title}</H1>

      <Section>
        <H2>1. Acuerdo del usuario</H2>
        <p>
          El sitio web del proyecto <i>La infancia en transformación</i> contiene materiales
          relacionados con el mandato del Fondo de las Naciones Unidas para la Infancia (UNICEF). En
          particular, en el sitio web figuran los resultados de una encuesta mundial que UNICEF
          llevó a cabo con sus aliados. El asunto de la encuesta fue “La infancia en el siglo XXI”.
          Los materiales disponibles incluyen, entre otros elementos, datos, visualizaciones,
          animaciones, vídeos, artículos y editoriales. El propósito de los materiales es ampliar la
          información y los conocimientos relacionados con determinados temas. Los contenidos del
          sitio web están destinados exclusivamente al uso personal y no tienen fines comerciales.
        </p>
        <p>
          Sírvase leer atentamente las presentes Condiciones de uso, que constituyen un acuerdo
          entre usted y UNICEF. Al seguir utilizando este sitio web, usted reconoce haber leído,
          entendido y aceptado los términos y condiciones que se presentan a continuación. Si no
          está de acuerdo con alguno de estos términos y condiciones, le rogamos se abstenga de
          utilizar este sitio web.
        </p>
        <p>
          Debido a que las presentes Condiciones de uso pueden modificarse sin previo aviso, le
          recomendamos visitar esta página para mantenerse al corriente de posibles actualizaciones.
          La fecha de las actualizaciones más recientes aparecerá al final de la página. Al seguir
          utilizando este sitio web estará manifestando que acepta cualquier cambio o actualización
          de las Condiciones de uso.
        </p>
        <p>
          En estas Condiciones de uso, “nosotros”, “nos” y “nuestro/a” hace referencia a UNICEF. Los
          términos “usted” “su” “sus” y “usuario” se refiere a usted en calidad de persona u
          organización que accede o utiliza este sitio web.
        </p>
      </Section>

      <Section>
        <H2>2. Contenido del sitio web y normas de uso</H2>
        <p>
          Este sitio web está abierto y disponible para todas las personas del mundo. El propósito
          de UNICEF para el sitio web del proyecto <i>La infancia en transformación</i> es crear un
          ambiente en el que cada persona se sienta cómoda, independientemente de su nacionalidad,
          género, bagaje cultural, religión, orientación sexual o ideología política.
        </p>
        <p>
          Usted acepta utilizar este sitio web solamente con fines legítimos y de forma que no se
          incumplan los derechos ni se restrinja o inhiba su uso y disfrute por parte de terceros.
        </p>
        <p>
          UNICEF es el titular y conserva todos los derechos relativos al código de fuente, el
          diseño, la funcionalidad y la arquitectura del sitio web, así como el programa
          informático, los materiales de apoyo o el contenido que se muestra en él (en conjunto, “la
          IP del sitio web del proyecto <i>La infancia en transformación</i>”). Con excepción de los
          derechos explícitamente concedidos en virtud de estas Condiciones de uso, usted no
          disfruta de ningún derecho en relación con la IP del sitio web del proyecto “
          <i>La infancia en transformación</i>”. Si desea utilizar la IP del sitio web del proyecto
          “<i>La infancia en transformación</i>” de una forma que no está permitida de conformidad
          con las presentes Condiciones de uso, deberá ponerse en contacto con el equipo del sitio
          web del proyecto “<i>La infancia en transformación</i>” con el fin de obtener una
          autorización escrita.
        </p>
        <p>
          A menos que se indique expresamente lo contrario, todos los materiales que UNICEF facilita
          a través de este sitio web cuentan con la licencia de Atribución-NoComercial-SinDerivadas
          4.0 Unported de Creative Commons. Esta licencia les permite a usted y a otras personas
          copiar y redistribuir el contenido del sitio web, pero no les concede autorización para
          alterar o transformar el contenido ni utilizarlo con fines comerciales. Asimismo, esta
          licencia le obliga a atribuir a su autor original cualquier material que desee utilizar.
          Al utilizar <strong>cualquier material de este sitio web</strong>, no olvide añadir la
          siguiente atribución: “Una encuesta de Gallup para UNICEF. Véase
          changingchildhood.unicef.org”. Si tiene alguna pregunta, sírvase visitar{' '}
          <A href="https://creativecommons.org/faq/">
            la página de Preguntas frecuentes de Creative Commons
          </A>
          , donde encontrará más información.
        </p>
        <p>
          Tenga en cuenta que este sitio y los materiales de apoyo pueden contener imágenes,
          materiales sonoros y vídeos registrados por terceros. Ninguna de las disposiciones de
          estas Condiciones de Uso o la licencia de Creative Commons limita o reduce la totalidad de
          los derechos de propiedad intelectual de terceros. Usted no podrá utilizar estos
          materiales para etiquetar, promocionar o hacer publicidad de productos o servicios. Usted
          es el único responsable de cualquier quebrantamiento de los derechos de propiedad
          intelectual de terceros ocasionado por su uso indebido de estos materiales.
        </p>
        <p>
          Usted acepta cumplir todas las leyes y normativas vigentes en su país al utilizar este
          sitio web.
        </p>
        <p>
          El sitio web del proyecto <i>La infancia en transformación</i> y los nombres y logotipos
          de UNICEF son propiedad exclusiva de UNICEF y están amparados por la legislación nacional
          e internacional. Está prohibido utilizarlos sin permiso y no podrán copiarse ni
          reproducirse de ninguna manera sin la autorización previa por escrito de UNICEF. Las
          solicitudes de permiso deben remitirse a{' '}
          <A href="mailto:nyhqdoc.permit@unicef.org">nyhqdoc.permit@unicef.org</A>. El resto de las
          marcas comerciales, marcas de servicio y logotipos utilizados en este sitio web, ya sea
          con o sin atribución, son las marcas comerciales, marcas de servicio y logotipos de sus
          respectivos titulares.
        </p>
        <p>
          UNICEF se reserva el derecho de emprender todas las medidas legales disponibles para
          combatir cualquier infracción de las presentes Condiciones de uso, incluida cualquier
          vulneración de los derechos de UNICEF con respecto al uso de su nombre y su emblema, así
          como sus derechos relativos a la información, las ilustraciones, los textos, los vídeos,
          los materiales sonoros, las fotos u otros contenidos del sitio web.
        </p>
      </Section>

      <Section>
        <H2>3. Privacidad, cookies y divulgación de información</H2>
        <p>
          Su privacidad es importante para nosotros. Sírvase consultar nuestra{' '}
          <A href="https://www.unicef.org/legal#privacy-policy">Política de privacidad</A>, que
          incluye más detalles sobre las limitaciones a la información del usuario que UNICEF
          recopila, almacena y utiliza, así como la forma en que lo hace. Asimismo, le recordamos
          que si continúa utilizando este sitio web estará reconociendo haber leído y aceptado
          nuestra <A href="https://www.unicef.org/legal#privacy-policy">Política de privacidad</A>.
        </p>
        <p>
          UNICEF utiliza cookies en este sitio web con el fin de realizar un seguimiento de su uso.
          Consulte la{' '}
          <A href="https://www.unicef.org/legal#unicef-cookies-policy">
            política de cookies de UNICEF
          </A>{' '}
          si desea conocer más detalles sobre la forma en que se emplean las cookies.
        </p>
        <p>
          UNICEF se compromete a poner a disposición del público la información relativa a sus
          programas y operaciones. Consulte la{' '}
          <A href="https://www.unicef.org/legal#information-disclosure-policy">
            Política de revelación de datos
          </A>{' '}
          de UNICEF para conocer más detalles.
        </p>
      </Section>

      <Section>
        <H2>4. Enlaces a otros sitios web</H2>
        <p>
          Este sitio web puede incluir enlaces a otras páginas que no controla UNICEF. UNICEF
          proporciona estos enlaces con fines meramente prácticos, y el hecho de incluirlos no
          significa que UNICEF apruebe o recomiende el sitio web, el producto o los servicios. Si
          usted decide acceder a los sitios web o aplicaciones de terceros a través de estos
          enlaces, lo hará bajo su propia cuenta y riesgo. UNICEF no asume ninguna responsabilidad u
          obligación con respecto a tales sitios web, como por ejemplo, la responsabilidad o la
          obligación de garantizar la exactitud y la fiabilidad de la información, los datos, las
          opiniones, las recomendaciones o las declaraciones que aparezcan .
        </p>
      </Section>

      <Section>
        <H2>5. Descargo de responsabilidad</H2>
        <p>
          Todo el contenido que UNICEF muestra en este sitio se expone tal y como es. Esto significa
          que no podemos garantizar la exactitud y la veracidad de la información contenida en esta
          página web.
        </p>
        <p>
          Las Naciones Unidas y UNICEF no aceptan responsabilidad ni obligación alguna derivada del
          uso de este sitio web o de su contenido. Las Naciones Unidas, así como UNICEF, sus
          funcionarios, empleados, consultores, agentes y contratistas no serán responsables de las
          consecuencias financieras o de otro tipo que puedan derivarse del uso de este sitio y de
          su contenido, incluido el uso inapropiado, indebido o fraudulento de tal contenido.
        </p>
        <p>
          UNICEF no acepta responsabilidad ni obligación alguna con respecto a la conducta de los
          usuarios en relación con este sitio web, ni en relación con cualquier material enviado por
          los usuarios o presente en este sitio, como por ejemplo la responsabilidad o la obligación
          de garantizar la exactitud o la fiabilidad de la información, los datos, las opiniones,
          las recomendaciones o las declaraciones que aparezcan en dicho material.
        </p>
        <p>
          UNICEF no garantiza que las funciones de los contenidos o los recursos de este sitio no
          puedan sufrir interrupciones o presentar errores, que sea posible corregir los defectos ni
          que este sitio o el servidor que posibilita su funcionamiento estén libres de virus o
          aseguren la total funcionalidad, exactitud y fiabilidad del contenido o los recursos. No
          se ofrecerán declaraciones ni garantías de ningún tipo en relación con este sitio web, ni
          se asumirán responsabilidades por la posible aparición de virus informáticos o cualquier
          otro tipo de contaminación o elemento que tenga propiedades destructivas.
        </p>
        <p>
          Usted se compromete a indemnizar por su propia cuenta a UNICEF, sus funcionarios,
          empleados, consultores y agentes frente a cualquier tipo de reclamación presentada por
          terceros, así como por los costos y gastos derivados de la misma, en relación con o como
          consecuencia de: a) el uso o el intento de uso por su parte de este sitio web, así como de
          los recursos o servicios, de una manera que contravenga el presente acuerdo; b) el
          incumplimiento por su parte de cualquier derecho de terceros; y c) cualquier contenido de
          usuarios que usted publique o ponga a disposición de otras personas en este sitio o a
          través de cualquier servicio, incluyendo, entre otros, cualquier reclamación por
          incumplimiento o apropiación indebida de los derechos de propiedad intelectual o de
          cualquier otro derecho de propiedad.
        </p>
        <p>
          A menos que se indique expresamente lo contrario en las presentes Condiciones de uso,
          UNICEF no ofrecerá al usuario declaraciones ni garantías de ningún tipo, ya sean expresas
          o implícitas, en relación con cualquiera de los servicios. Por ejemplo, no nos haremos
          responsables del contenido que se presenta en los servicios, de las funciones específicas
          de los servicios ni de su fiabilidad, disponibilidad o capacidad para satisfacer sus
          necesidades. Por la presente, UNICEF rechaza todas las garantías implícitas de
          comercialización e idoneidad para un determinado fin y el no incumplimiento con respecto a
          todo lo expuesto con anterioridad.
        </p>
        <p>
          UNICEF añade, modifica, mejora o actualiza regularmente los materiales de este sitio web
          sin previo aviso. UNICEF no asumirá en ningún caso la responsabilidad por posibles
          pérdidas, daños, obligaciones o gastos contraídos o sufridos presuntamente como resultado
          del uso de este sitio web, incluyendo, entre otros, cualquier fallo, error, omisión,
          interrupción o retraso. El usuario utilizará este sitio web bajo su propia cuenta y
          riesgo. UNICEF y sus aliados no serán responsables en ningún caso de posibles daños,
          incluyendo, sin limitación, la negligencia, ni tan siquiera si a UNICEF se le advierte de
          la posibilidad de que se produzcan tales daños. Asegúrese de utilizar el contenido de este
          sitio web de una manera cuidadosa y responsable.
        </p>
        <p>
          Usted reconoce que es el único responsable de cualquier problema que pueda surgir como
          resultado del uso de este sitio web. En ningún caso se le atribuirá a UNICEF la
          responsabilidad con respecto a los daños o perjuicios que usted pueda haber asociado al
          uso de este sitio web.
        </p>
        <p>
          La mención de nombres de empresas o productos específicos en este sitio web no conlleva la
          intención de infringir los derechos de propiedad, ni tampoco debería interpretarse como
          una aprobación o recomendación por parte de UNICEF.
        </p>
        <p>
          La utilización de designaciones concretas de países, territorios o mapas en este sitio web
          no refleja la postura de UNICEF con respecto a la situación jurídica de dichos países o
          territorios, de sus autoridades e instituciones ni el reconocimiento de ninguna frontera.
        </p>
      </Section>

      <Section>
        <H2>6. Privilegios e inmunidades</H2>
        <p>
          Ninguna de las disposiciones que figuran en las presentes Condiciones de uso o en relación
          con estas deberán considerarse una renuncia expresa o implícita o de cualquier otro tipo a
          los privilegios y las inmunidades de UNICEF, de conformidad con la Convención sobre
          privilegios e inmunidades de las Naciones Unidas de 1946.
        </p>
      </Section>

      <Section>
        <H2>7. Póngase en contacto con nosotros</H2>
        <p>
          Si tiene alguna pregunta relacionada con este sitio web, sírvase utilizar el{' '}
          <A href="https://www.unicef.org/about-unicef/contact-us">formulario de comentarios</A>.
        </p>
      </Section>

      <footer>
        <p>Última actualización: 12 de julio de 2021</p>
      </footer>
    </>
  );
}
